/*
 * Created by Joseph Saliba on 10/22/16.
 */
namespace app.model.user {
  export enum DisplayMode {
    ListView,
    GridView
  }

  export class Preferences {
    public static get TAG_RELATED() {
      return "tr";
    }

    public static get TAG_REPORT_PROJECT() {
      return "trp";
    }

    public static get TAG_REPORT_SYSTEM() {
      return "trs";
    }

    public static get TAG_REPORT_DOMAIN() {
      return "trd";
    }

    public static get TAG_REPORT_BATCH() {
      return "trb";
    }

    public static get DISPLAY_MODE() {
      return "DisplayMode";
    }

    public static get GRID_COLUMNS() {
      return "GridColumns";
    }

    public static get GRID_COLUMNS_SORT_MODEL() {
      return "GridColumnsSortModel";
    }

    public static get GRID_COLUMNS_FILTER_MODEL() {
      return "GridColumnsFilterModel";
    }
  }
}

// Expose as window global so bare `Preferences` references in other namespace files resolve
(window as any).Preferences = app.model.user.Preferences;
(window as any).DisplayMode = app.model.user.DisplayMode;


